module.exports = __webpack_public_path__ + "media/gateway/question-30e3d9a9.png";